import React from "react";
import QRCode from "react-qr-code";
const PlayStoreQr = () => {
  return (
    <div style={{ width: "150px", height: "150px" }}>
      <QRCode
        size={150}
        //   bgColor='transparent'
        fgColor="black"
        value="https://play.google.com/store/apps/details?id=com.athlink.app"
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default PlayStoreQr;
